/**
 * Gate the import report document ID based on whether the referenced
 * Import Report document is in the project's active contents array.
 *
 * When the import report is trashed or permanently deleted, it won't
 * appear in `contents`, so this returns null — suppressing the import
 * conversation starters.
 *
 * When `contents` is null (not yet loaded), we treat the report as
 * active to avoid a flash of wrong starters on initial load.
 */
export function gateImportReportDocumentId(
  reportId: string | null | undefined,
  contents: Array<{ id?: string | null }> | null | undefined,
): string | null {
  if (reportId == null) return null;
  // contents not yet loaded — assume active to avoid flash
  if (!Array.isArray(contents)) return reportId;
  return contents.some(
    (item) => item?.id != null && String(item.id).trim() === String(reportId).trim(),
  )
    ? reportId
    : null;
}
